module.exports = __webpack_public_path__ + "static/media/video.134eca5a.svg";